import {Routes} from '@angular/router';
import {EditComponent} from "./edit/edit.component";

export const BoundariesActivityRoutes: Routes = [
  {
    path: 'boundaries-activity/edit', component: EditComponent
  }

];
